import PlateAppearanceResult from "../../enums/PlateAppearanceResult.js";

// @see https://www.mlb.com/glossary/standard-stats/single
// A single occurs when a batter hits the ball and reaches first base without the help of an intervening error or attempt to put out another baserunner. Singles are the most common type of hit in baseball, and they occur in many varieties. If a batter beats out a bunt or an infield dribbler -- it's a single. And if a batter hits a rocket to the outfield wall but is held at first base -- it's also a single. (A batter is still credited with a single if he reaches first safely but is thrown out while trying to advance to second.)
const classifiesAsSingle = function(paResult) {
    switch (paResult) {
        case PlateAppearanceResult.Single.key:
        //case PlateAppearanceResult.Unidentified.key:
            return true;

        default:
            return false;
    }
};

export default classifiesAsSingle;